import {isEmptyOrNull, isNullOrUndefined, nextId} from "../../common/NamaCommon";
import * as ts from "../../common/Translator";
import {translateIdAr, translateIdEn} from "../../common/Translator";
import {currentUserEmployeeId} from "../../login/LoginPresenter";
import * as CommonConstants from '../../constants/CommonConstants'
import * as ApprovalDecision from '../../constants/ApprovalDecision'
import ApprovalEditTemplate from "../../compiled-templates/ApprovalEditTemplate";
import {calcDisplayString} from "./ApprovalUtils";
import {dropDownFiltering} from "../../widgets/DropDownListWidget";
import {getCustomGUISettings} from "../../login/ClientCache";
import {ReferenceWidget} from "../../widgets/ReferenceWidget";
import {normalizeArabic} from "../../common/StringUtils";
import {AttachmentWidget} from "../../widgets/AttachmentWidget";

export class ApproveEditScreen {
    /**
     *
     * @param {EditPresenter} presenter
     */
    constructor(presenter, approvalCase, currApprovalCase_) {
        this.presenter = presenter;
        let currApprovalCase = null;
        if (presenter.currentApprovalCase)
            currApprovalCase = presenter.currentApprovalCase();
        if (currApprovalCase_)
            currApprovalCase = currApprovalCase_;
        this.approvalCase = approvalCase || currApprovalCase;
    }

    showPopup() {
        let that = this;
        if (!that.approvalCase)
            return;
        that._initUI();
        if (!calcConcernedLines(that.approvalCase)) {
            that.rootElement.find("#approvedLinesInp").remove();
            that.rootElement.find("#concernedLinesInp").remove();
        }
        that.kendowWindow.open().center();
    }

    _initUI() {
        let that = this;
        that.elementId = nextId();
        let concernedLines_ = calcConcernedLines(that.approvalCase);
        that.rootElement = $(ApprovalEditTemplate({
            translateId: ts.translateId,
            approvalCase: that.approvalCase,
            nextStepName: ts.selectNameBasedOnLang(that.approvalCase.nextStepName1, that.approvalCase.nextStepName2) || "&nbsp",
            elementId: that.elementId,
            concernedLines: concernedLines_ || "&nbsp",
        }));
        if (isEmptyOrNull(calcDisplayString(concernedLines_)))
            that.rootElement.find("#approvedLinesDiv").remove();
        let owner = {};
        owner.rootElement = () => {
            return that.rootElement
        };
        let approvalReason = new ReferenceWidget({
            owner: owner,
            fieldMetadata: {fieldId: "approvalReason", referencedEntityType: "ApprovalReason"},
            width: 20
        });
        let attachment = new AttachmentWidget({
            owner: owner,
            fieldMetadata: {fieldId: "attachment", fieldType: "Binary"},
            width: 20
        });
        approvalReason.render().appendTo(that.rootElement.find("#appReasonRef"));
        approvalReason.afterAttach();
        attachment.render().appendTo(that.rootElement.find("#attachment"));
        attachment.afterAttach();
        /**
         * @type {kendo.ui.Window}
         */
        that.kendowWindow = that.rootElement.kendoWindow({
            title: ts.translateId("Approve"),
            maxWidth: "80%",
            maxHeight: "80%",
            minHeight: "50%",
            minWidth: "50%",
            resizable: true,
            scrollable: true,
            modal: true,
            actions: [
                "Close"
            ],
            close: function (e) {
                that.kendowWindow.destroy()
            }
        }).data("kendoWindow");

        let dataSource = [{text: "", value: ""}];
        dataSource.push({text: ts.translateId(ApprovalDecision.Approve), value: ApprovalDecision.Approve});
        if (isNullOrUndefined(getCustomGUISettings().useRejectDecision) || getCustomGUISettings().useRejectDecision === true)
            dataSource.push({text: ts.translateId(ApprovalDecision.Reject), value: ApprovalDecision.Reject});
        if (isNullOrUndefined(getCustomGUISettings().useReturnDecision) || getCustomGUISettings().useReturnDecision === true)
            dataSource.push({text: ts.translateId(ApprovalDecision.Return), value: ApprovalDecision.Return});
        if (isNullOrUndefined(getCustomGUISettings().useEscalateToSupervisor) || getCustomGUISettings().useEscalateToSupervisor === true)
            dataSource.push({text: ts.translateId(ApprovalDecision.EscalateToSupervisor), value: ApprovalDecision.EscalateToSupervisor});
        if (isNullOrUndefined(getCustomGUISettings().useReturnToPreviousStep) || getCustomGUISettings().useReturnToPreviousStep === true)
            dataSource.push({text: ts.translateId(ApprovalDecision.ReturnToPreviousStep), value: ApprovalDecision.ReturnToPreviousStep});
        for (let d of dataSource) {
            let arabic = translateIdAr(d.value).trim();
            let english = translateIdEn(d.value).trim();
            d.searchData = d.value + " " + arabic + " " + english + " " + normalizeArabic(arabic);
        }
        that.decisionCombo = that.rootElement.find("#" + that.elementId + "decisionCombo").kendoDropDownList({
            dataTextField: "text",
            dataValueField: "value",
            placeholder: ts.translateId("selectApproveDecision"),
            dataSource: dataSource,
            filter: "contains",
            suggest: true,
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
        }).data("kendoDropDownList");

        let approvedLines = that.rootElement.find("#" + that.elementId + "approvedLinesInp");
        let remarks = that.rootElement.find("#" + that.elementId + "remarksInput");
        let okBtn = that.rootElement.find("#" + that.elementId + "okBtn");
        let cancelBtn = that.rootElement.find("#" + that.elementId + "cancelBtn");

        okBtn.on("click", (e) => {
            let that = this;
            /**
             *
             * @type {namaTypes.ApproveRequest}
             */
            let request = {
                decision: that.decisionCombo.value(),
                entityType: that.presenter.entityType,
                entityId: that.presenter.id,
                comment: remarks.val(),
                stepSequence: that.approvalCase.nextStepSequence,
                approvedLines: approvedLines.val(),
                approverId: currentUserEmployeeId(),
                approvalReasonIdOrCode: approvalReason.readValueFromElement() ? approvalReason.readValueFromElement().id : "",
                attachment: attachment.readValueFromElement(),
            };
            that.presenter.performApprove(request);
            that.kendowWindow.destroy();
        });
        cancelBtn.on("click", (e) => {
            that.kendowWindow.destroy();
        })
    }
}

/**
 *
 * @param {namaTypes.DTOApprovalCase} approvalCase
 * @returns {string}
 */
function calcConcernedLines(approvalCase) {
    let candidates = approvalCase.currentCandidates;
    if (!candidates)
        return "";
    let parts = candidates.split(CommonConstants.SEPARATOR);
    let employeeId = currentUserEmployeeId();
    for (let part of parts) {
        if (part.startsWith(employeeId))
            return part.substring(employeeId.length + 1);
    }
    return ""
}





